import React from "react";

const MediaGiphy = ({ url }) => <img src={url} alt="gif" />;

export { MediaGiphy };
